var map = {
	"./Sidebar-dot-bg.png": "80da",
	"./grid-white-x2.png": "ed0b",
	"./grid-white.png": "30af",
	"./icon-<.png": "0235",
	"./icon->.png": "0ccc",
	"./icon-adjustments.png": "ebd3",
	"./icon-adversary.png": "62ae",
	"./icon-advocate.png": "ae30",
	"./icon-axis.png": "0749",
	"./icon-difficulty.png": "31e0",
	"./icon-discuss.png": "86e5",
	"./icon-help.png": "2263",
	"./icon-hint.png": "5cc9",
	"./icon-identity.png": "5b64",
	"./icon-logo.png": "9b79",
	"./icon-names.png": "6f09",
	"./icon-operator.png": "29d2",
	"./icon-outcomes.png": "4e20",
	"./icon-participant.png": "68fc",
	"./icon-pledge.png": "d17a",
	"./icon-questionnaire.png": "62a2",
	"./icon-scenario.png": "8b93",
	"./icon-side.png": "33d5",
	"./icon-sprite.png": "bb33",
	"./icon-strategy.png": "d32a",
	"./icon-tab.png": "9da6",
	"./icon-tactic.png": "2ad8",
	"./icon-task.png": "ca76",
	"./icon-timer.png": "125b",
	"./icon-volume.png": "7da5",
	"./icon-welcome.png": "cfec",
	"./page-blank.png": "ddb0",
	"./page-timer-black.png": "885d",
	"./page-timer.png": "8652",
	"./radio-button-sprite.png": "3713"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";